import React from 'react';
import Badge from '../../ui/Badge/Badge';
import './BillingDisplayRows.less';

/**
 * The billing rows of a session, exactly as the backend worded them
 * (see `utils/billingDisplay.js`). Shared by the receipt, the session
 * detail page and the post-charge summary.
 *
 * `view` is the result of `resolveBillingDisplay`. `variant="panel"`
 * matches the label/value rows of the charging wizard's InfoPanel.
 *
 * `withChargeRows` prints the stored charge components
 * (`display.chargeRows` — usage charge, session fee, adjustments, tax)
 * ahead of the billing rows, in the same list. They are the server's
 * figures; there may be none.
 */
function BillingDisplayRows({ view, variant = 'receipt', withChargeRows = false, className = '' }) {
  if (!view || !Array.isArray(view.rows) || view.rows.length === 0) return null;
  const chargeRows = withChargeRows && Array.isArray(view.chargeRows) ? view.chargeRows : [];

  return (
    <dl className={`gc-billing-rows gc-billing-rows--${variant} ${className}`.trim()}>
      {chargeRows.map((row) => (
        <div
          key={`charge-${row.key}`}
          className="gc-billing-row is-charge"
          data-billing-charge-row={row.key}
        >
          <dt className="gc-billing-row-label">{row.label}</dt>
          <dd className="gc-billing-row-value">{row.value}</dd>
        </div>
      ))}
      {view.rows.map((row) => (
        <div
          key={row.key}
          className={`gc-billing-row${row.emphasis ? ' is-emph' : ''}`}
          data-billing-row={row.key}
        >
          <dt className="gc-billing-row-label">{row.label}</dt>
          <dd className="gc-billing-row-value">
            {row.tone ? <Badge tone={row.tone}>{row.value}</Badge> : row.value}
          </dd>
        </div>
      ))}
    </dl>
  );
}

export default BillingDisplayRows;
